import { AxiosResponse } from 'axios';
import { ApiPackagesSupportService } from 'services';

// Mapeo de tariffProvider a powerProviderId
const mapTariffProviderToPowerProviderId = (tariffProviderId: string): string | null => {
	const mapping: Record<string, string> = {
		'5663cb81-270c-465f-8a0c-322dc2ccd35f': 'hyd',
		'1f129439-e49a-4707-a9b0-3cb9c2cc53dd': 'nexus',
	};
	return mapping[tariffProviderId] || null;
};

// Tipos para la respuesta de la API
export interface IVoucherResponse {
	status: string;
	saleOrderId?: string;
	powerServiceId?: string;
	powerProviderId?: string;
	reservationCode?: string;
	estado?: string;
	localizer?: string;
	contacto?: string;
	total?: string;
	pasajeros?: Array<{
		nombre: string;
		apellido: string;
	}>;
	vouchers?: Array<{
		serviceId: string;
		url: string;
	}>;
	generatedAt?: string;
	jsonUrl?: string;
}

export interface IVoucherDownloadParams {
	saleOrderId: string;
	powerServiceId: string;
	tariffProviderId: string;
	reservationCode: string;
	serviceType: string;
	servicePassengers: string;
	force?: boolean;
}

// Función para descargar vouchers
export const downloadVouchers = async (params: IVoucherDownloadParams): Promise<AxiosResponse<IVoucherResponse[]>> => {
	const powerProviderId = mapTariffProviderToPowerProviderId(params.tariffProviderId);

	if (!powerProviderId) {
		throw new Error('Proveedor no soportado para descarga de vouchers');
	}

	// X-Api-Key y X-Auth-Token se agregan automáticamente por el interceptor de ApiPackagesSupportService.
	// La baseURL ya apunta a REACT_APP_SUPPORT_API_BASE_URL (incluye /api).
	return ApiPackagesSupportService.get<IVoucherResponse[]>('vouchers', {
		params: {
			saleOrderId: params.saleOrderId,
			powerServiceId: params.powerServiceId,
			powerProviderId,
			reservationCode: params.reservationCode,
			serviceType: params.serviceType,
			servicePassengers: params.servicePassengers,
			...(params.force ? { force: true } : {}),
		},
	});
};

export { mapTariffProviderToPowerProviderId };
